import { node, number } from "prop-types";
import { forwardRef } from "react";

import styled from "styled-components";

const SDiv = styled("div")`
  transform: scale(${({ $scale }) => $scale});
  transition: transform 300ms;
`;

const FnrScaleIt = forwardRef(
  /**
   * "Let's just make that size a <em>little</em> bit different."
   * @param {object} param0
   * @param {number} param0.scale - percentage of original in decimals
   */
  ({ children, scale = 0.75, ...rest }, ref) => (
    <SDiv $scale={scale} ref={ref} {...rest}>
      {children}
    </SDiv>
  )
);

FnrScaleIt.propTypes = { children: node, scale: number };

export default FnrScaleIt;
